import { render, staticRenderFns } from "./AtlasPlatformAllActivities.vue?vue&type=template&id=991de57e"
import script from "./AtlasPlatformAllActivities.vue?vue&type=script&lang=ts"
export * from "./AtlasPlatformAllActivities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports